import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsVelomobileNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sports_velomobile_normal_large_svg__clip0_138_115)">
        <path
          d="M48 24.28a4.579 4.579 0 00-2.17-3.88l-.2-.12a19.89 19.89 0 00-11.67-2.92l-9.32.55-.23-.43A8.406 8.406 0 0016.96 13a25.57 25.57 0 00-12.58 3.32L.13 18.73l.42 2.06 4.96-2.81A23.5 23.5 0 0112 15.543v.9a3.977 3.977 0 003.979 3.977c.077 0 .155 0 .232-.007L34.08 19.35a18.02 18.02 0 0110.5 2.63l.2.13a2.553 2.553 0 01.25 4.18A12.47 12.47 0 0137.28 29h-.8a5.5 5.5 0 00-10.95 0H4.25L2.8 21.81.97 22.85 2.62 31H5.1a5 5 0 009.8 0h10.813a5.494 5.494 0 0010.574 0h.993a14.517 14.517 0 009-3.15A4.544 4.544 0 0048 24.28zm-31.907-5.863A1.974 1.974 0 0114 16.444v-1.255A23.25 23.25 0 0116.96 15a6.425 6.425 0 015.46 3.043l-6.327.374zM10 33a3 3 0 01-2.816-2h5.632A3 3 0 0110 33zm21 0a3.5 3.5 0 110-7.001A3.5 3.5 0 0131 33z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="sports_velomobile_normal_large_svg__clip0_138_115">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsVelomobileNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsVelomobileNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsVelomobileNormalLarge;
